import { createSlice } from '@reduxjs/toolkit';
import { StatusState } from './types';
import { fetchPaymentsStatus } from './thunk';

const initialState: StatusState = {
  data: null,
  loading: false,
  error: null,
};

const statusSlice = createSlice({
  name: 'payments/status',
  initialState,
  reducers: {
    resetPaymentsStatus: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentsStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentsStatus.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload;
      })
      .addCase(fetchPaymentsStatus.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload ?? 'Failed to load payment status';
      });
  },
});

export const { resetPaymentsStatus } = statusSlice.actions;
export default statusSlice.reducer;
